import {useEffect, useState} from "react";
import {BehaviorSubject, Subject} from "rxjs";
import {showError} from "../components/Notification";

export const useSubject = (subject: BehaviorSubject<any> | Subject<any>, callback?: any): any => {
    const [value, setValue] = useState(subject instanceof BehaviorSubject ? subject.getValue() : null);
    useEffect(() => {
        const subscription = subject.subscribe((value) => {
            setValue(value);
            !!callback && callback(value);
        });
        return () => subscription.unsubscribe();
    }, [subject]);
    return value;
};

export const hookFromSubject = (subject: BehaviorSubject<any> | Subject<any>): Function => () => useSubject(subject);

export class ResponseSubjectState {
    constructor(public data: any = null, public loading: boolean = false, public error: any = null) {
    }
}

export interface PromiseToSubjectOptions {
    suppressErrors?: boolean;
}

export const promiseToSubject = (promise: Promise<any>, subject: BehaviorSubject<any>, options: PromiseToSubjectOptions = {}): Promise<any> => {
    const fallbackSubject = subject.getValue() ? subject.getValue().data : null;
    subject.next(new ResponseSubjectState(fallbackSubject, true));
    promise.then(
        data => subject.next(new ResponseSubjectState(data, false)),
        async error => {
            if (error.status === 401) {
                window.location.reload();
            } else {
                try {
                    const errorResponse = await error.json();
                    error.message = errorResponse.Message;
                } catch (e: any) {
                    error.message = e.message;
                }
                subject.next(new ResponseSubjectState(fallbackSubject, false, error));
                if (!options.suppressErrors) {
                    showError(error.message
                            ? 'Error'
                            : (error.error || error.statusText || ('Response status: ' + error.status)),
                        error.message
                    );
                }
            }
        }
    );
    return promise;
};

export const filtersSubject = new BehaviorSubject({});
export const useFilters = hookFromSubject(filtersSubject);
